import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { isNull, get } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import EmptySelectedInboxes from 'containers/AttributionManager/EmptySelectedInboxes';
import ManagerInboxes from 'containers/AttributionManager/ManagerInboxes';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import { INBOXES_TYPES } from 'containers/AttributionManager/constants';
import {
  StyledContainer,
  StyledGridItem,
} from 'containers/AttributionManager/styles';
import {
  makeSelectUserInboxes,
  makeSelectManagers,
  makeSelectCountInboxes,
} from 'containers/AttributionManager/selector';
import { makeSelectNotificationsInboxes } from 'containers/AppContainer/selectors';
import {
  requestGetUsersInboxes,
  requestGetManagersBawaba,
  requestUpdateAssignementInboxes,
  requestGetCountInboxes,
} from 'containers/AttributionManager/action';
import { extractUser } from 'containers/AttributionManager/utils';
import ManagerContainer from 'containers/AttributionManager/ManagerCard/ManagerContainer';
export interface AttributionManagerProps {
  intl: IntlShape;
  listings: any;
  usersInboxes: any;
  managers: any;
  requestGetUsersInboxes: Function;
  requestGetManagersBawaba: Function;
  requestUpdateAssignementInboxes: Function;
  managerNotifications: any;
  requestGetCountInboxes: Function;
  countInboxes: any;
}

export const AttributionOpeningManagerPage: React.FC<AttributionManagerProps> = (
  props,
): JSX.Element => {
  const [selectedInboxe, setSelectedInboxe] = useState(null);
  useEffect(() => {
    props.requestGetUsersInboxes();
    props.requestGetManagersBawaba();
    props.requestGetCountInboxes();
  }, []);
  return (
    <Grid
      container
      direction="row"
      style={{ ...StyledContainer, position: 'absolute' }}
      spacing={2}
    >
      <Grid item>
        <ManagerInboxes
          listings={props.listings}
          setSelectedInboxe={setSelectedInboxe}
          selectedInboxe={selectedInboxe}
          managers={props.managers}
          managerNotifications={props.managerNotifications}
          usersInboxes={props.usersInboxes}
          countInboxes={props.countInboxes}
          inboxes={get(props.listings, 'managerInboxes', []).filter(
            /* istanbul ignore next */ (el: any) =>
              el.type === INBOXES_TYPES.OPENING,
          )}
        />
      </Grid>
      <Grid item xs style={StyledGridItem}>
        {isNull(selectedInboxe) ? (
          <EmptySelectedInboxes />
        ) : (
          <ManagerContainer
            usersInboxe={extractUser(props.usersInboxes, selectedInboxe)}
            usersInboxes={props.usersInboxes}
            managers={props.managers}
            requestUpdateAssignementInboxes={
              props.requestUpdateAssignementInboxes
            }
            requestGetUsersInboxes={props.requestGetUsersInboxes}
            selectedInboxe={selectedInboxe}
            countInboxes={props.countInboxes}
            listings={props.listings}
          />
        )}
      </Grid>
    </Grid>
  );
};

const mapDispatchToProps = {
  requestGetUsersInboxes,
  requestGetManagersBawaba,
  requestUpdateAssignementInboxes,
  requestGetCountInboxes,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  usersInboxes: makeSelectUserInboxes(),
  managers: makeSelectManagers(),
  managerNotifications: makeSelectNotificationsInboxes(),
  countInboxes: makeSelectCountInboxes(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AttributionOpeningManagerPage));
